/**
 * Created by Languagenut on 09/12/2019.
 */


import React from 'react';
import Base from '../wizards/assignments/activities_type.js';
import {Row , Col} from 'react-bootstrap'
import Translation from '../../store/internationalization-store.js';
import Wizard from '../wizards/wizard.js';
import Select from '../wizards/certificates/select-certificate.js'
import Who from '../wizards/certificates/select-who.js';
import Generate from '../wizards/certificates/select-generate.js';

export default class Certificates extends Base.component {

    constructor(props) {
        super();
        this.props = {}
        this.props.data = {};
        this.state = {
            key:0
        }
    }

    set(){
        this.setLanguageValue.apply(this , arguments);
        this.setState({
            key:0
        })
    }

    render(){
        let steps = [Select , Who , Generate];
        return <div>
            <Row>
                <Col md={6}>
                    <div class="d-flex align-items-left">
                        <div class="p-2 report_title">
                            {Translation.get(330 , 'Printable Resources')}
                        </div>
                    </div>
                </Col>
            </Row>
            <Row>
                <Col md={12}>
                    <Wizard stepsNavigation={true} steps={steps} />
                </Col>
            </Row>
        </div>;


    }
}
